import { Box, Typography } from "@mui/material"
import { normaliseHtml } from "./pdf-formatters"
import { sanitizeAmendsHtml } from "../../project/amends/lib/sanitize-amends-html"
import { removeEmptyListItems } from "./remove-empty-list-items"

export function PdfRichTextBlock({ html }) {
    const safeHtml = removeEmptyListItems(sanitizeAmendsHtml(html))

    if (!normaliseHtml(safeHtml)) {
        return <Typography sx={{ fontSize: "10px", color: "#9ca3af", fontStyle: "italic" }}>No content</Typography>
    }

    return (
        <Box
            className="styled-bullets"
            sx={{
                fontSize: "10px",
                lineHeight: 1.7,
                color: "#374151",
                "& p": { m: 0, mb: "8px" },
                "& ul, & ol": { my: "8px", pl: "18px" },
                "& li": { mb: "4px" },
                "& img": { maxWidth: "100%" },
            }}
            dangerouslySetInnerHTML={{ __html: safeHtml }}
        />
    )
}
